// src/index.js

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppContent from "./App";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MaterialUIControllerProvider } from "context";
import { SnackbarProvider } from "context/SnackbarContext";
import { AuthProvider } from "context/AuthContext";
import { CompanyProvider } from "context/CompanyContext";
import { LanguageProvider } from "context/LanguageContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"; // Importuojame Devtools

// Sukuriame QueryClient instanciją su išjungtu cache
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0, // Completely disable caching
      staleTime: 0, // Data is always considered stale
      refetchOnMount: true, // Always refetch when component mounts
      refetchOnWindowFocus: true, // Always refetch on window focus
    },
  },
});

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MaterialUIControllerProvider>
            <LanguageProvider>
              <SnackbarProvider>
                <AuthProvider>
                  <CompanyProvider>
                    <AppContent />
                  </CompanyProvider>
                </AuthProvider>
              </SnackbarProvider>
            </LanguageProvider>
          </MaterialUIControllerProvider>
        </LocalizationProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
